import React from "react"
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { Card, CardVariants } from "../../../designSystem/Card";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { P } from "../../../designSystem/typography/Body";
import { H2, H3 } from "../../../designSystem/typography/Heading";
import { MessageCard } from "../../../designSystem/Message";
import { CardButton } from "../../../designSystem/CardButton";
import { DesignSystemOverviewLayout, DesignSystemSection } from "../DesignSystemHelpers";
import { SimpleStatCard, StatCard, StatCardRow } from "../../../designSystem/StatCard";
import { IconWithText } from "../../../designSystem/compositeComponents/compositeIcons/IconWithText";


export const CardsOverview = (): JSX.Element => 
{
    
    return (
     
    <DesignSystemOverviewLayout>

        <DesignSystemSection title="StatCard">
            <StatCardRow>
                <SimpleStatCard header="SimpleStatCard" stat="124" subText="With a subText" />
                <SimpleStatCard header="SimpleStatCard" stat="24" />
                <StatCard header="RegularContent"  subText="This is an example stat card">
                    <IconWithText icon="assignment"variant="success" tooltipContent="The tooltip">Some text with tooltip</IconWithText>
                </StatCard>
            </StatCardRow>
        </DesignSystemSection>
        
        <DesignSystemSection title="CardButtons">
            {CardVariants.map(variant =>
                <Flex key={variant} gap={8}>
                    
                    <CardButton variant={variant}>
                        <H3>CardButton variant: {variant}</H3>
                        <P>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </P>
                    </CardButton>

                    <CardButton variant={variant} disabled>
                        <H3>variant: {variant} disabled</H3>
                        <P>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </P>
                    </CardButton>

                </Flex>
            )}
        </DesignSystemSection>
        
        <DesignSystemSection title="Cards">
            {CardVariants.map(variant =>
                <Flex key={variant} gap={8}>
                    
                    <Card variant={variant}>
                        <H3>Card variant: {variant}</H3>
                        <P>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </P>
                    </Card>
                </Flex>
            )}
        </DesignSystemSection>

        



        <DesignSystemSection title="Misc Cards">
            <Flex flexDirection="row" gap={10} justifyContent="space-between">
                <Card>
                    <H3>This is a default card</H3>
                    <H3>...with just a paragraph</H3>
                    <P>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                    </P>
                </Card>
                <Card>
                    <H2>This is a default card</H2>
                    <Card variant="outlined">
                        <H3>...with a light child card</H3>
                        <P>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </P>
                        <Card variant="attention">
                            <P>With an attention child card</P>
                        </Card>
                    </Card>
                </Card>
            </Flex>

            <Flex flexDirection="row" gap={10} justifyContent="space-between">
                <Card>Leggings roof party edison bulb gochujang craft beer. Fam +1 unicorn vinyl literally sriracha kickstarter keytar fanny pack echo park. Shaman kickstarter marfa polaroid. Sriracha fingerstache unicorn drinking vinegar meditation. Cloud bread synth kitsch, cold-pressed hell of artisan tumblr stumptown.</Card>
                <Card>Leggings roof party edison bulb gochujang craft beer. Fam +1 unicorn vinyl literally sriracha kickstarter keytar fanny pack echo park. Shaman kickstarter marfa polaroid. Sriracha fingerstache unicorn drinking vinegar meditation. Cloud bread synth kitsch, cold-pressed hell of artisan tumblr stumptown.</Card>
            </Flex>
        </DesignSystemSection>

        <DesignSystemSection title="Card - no padding">
            <Flex flexDirection="row" gap={10} justifyContent="space-between">
                <ButtonRow variant="stretched">
                    <Card padding="0px">Leggings roof party edison bulb gochujang craft beer. Fam +1 unicorn vinyl literally sriracha kickstarter keytar fanny pack echo park. Shaman kickstarter marfa polaroid. Sriracha fingerstache unicorn drinking vinegar meditation. Cloud bread synth kitsch, cold-pressed hell of artisan tumblr stumptown.</Card>
                    <Card padding="0px">Leggings roof party edison bulb gochujang craft beer. Fam +1 unicorn vinyl literally sriracha kickstarter keytar fanny pack echo park. Shaman kickstarter marfa polaroid. Sriracha fingerstache unicorn drinking vinegar meditation. Cloud bread synth kitsch, cold-pressed hell of artisan tumblr stumptown.</Card>
                </ButtonRow>
            </Flex>
        </DesignSystemSection>

        <DesignSystemSection title="Message">
            <Flex flexDirection="row" gap={10} justifyContent="space-between">
                <ButtonRow variant="stretched">
                    <MessageCard variant="info">Info: Pok pok vice bicycle rights crucifix DIY. Put a bird on it gorpcore keytar gentrify hot chicken live-edge semiotics.</MessageCard>
                    <MessageCard variant='success'>Success: Affogato lyft blog microdosing, meditation deep v fixie. Iceland tumeric listicle 3 wolf moon activated charcoal twee.</MessageCard>
                    <MessageCard variant="warning">Alert: Fit health goth hexagon, adaptogen meditation mustache jean shorts keytar vinyl sartorial scenester.</MessageCard>
                    <MessageCard variant="error">Error: Big mood sustainable readymade crucifix jean shorts four loko pabst kitsch.</MessageCard>
                </ButtonRow>
            </Flex>
        </DesignSystemSection>
             
    </DesignSystemOverviewLayout>
    );
}